import {  getUserAuthority } from '@/api/account'
import {login} from '@/api/user'
import ElementUI from 'element-ui'
import router from '@/router'
const state = {
  token: localStorage.getItem('token'),
  userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
  authority: []
}
const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  authority: state => state.authority
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_AUTHORITY: (state, authority) => {
    state.authority = authority

  }
}

const actions = {
  // 用户登录
  login({ commit ,dispatch}, userInfo) {
    const { name, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ name: name.trim(), password: password })
        .then(async (response) => {
          const { token, userInfo } = response
          localStorage.setItem('token', token)
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', userInfo)
          await dispatch("getUserAuthority")
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 获取用户权限
  getUserAuthority({ commit, state ,dispatch}) {
    // 如果已经有权限数据，直接返回
    if (state.authority && state.authority.length > 0) {
      return Promise.resolve()
    }
    if(!state.token){
      dispatch("logout")
      router.replace('/login')
      return Promise.resolve({msg:'请先登录'})
    }
    return new Promise((resolve, reject) => {
      getUserAuthority().then(response => {
        commit('SET_AUTHORITY', response.node_list.split(','))
        resolve()
      }).catch(error => {
        ElementUI.Message.error(error.msg||'获取权限失败')
        // 退出登录
        router.replace('/login')
        dispatch("logout")

        // reject(error)
      })
    })
  },
  // 用户登出
  logout({ commit }) {
    return new Promise(resolve => {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      commit('SET_AUTHORITY', [])
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
